import { ExpandMore } from '@mui/icons-material';
import KitchenIndentTable from '../../../../components/commonComponent/KitchenIndentTable';
import { IconPlus } from '../../../../icons/Icon';
import { formatCost } from '../../../../utils/format';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { addMog, fetchKitchenIndent, saveKitchenIndent } from '../../../../services/kitchenIndentProductionPlanSlice';

interface AccordionProps {
  openIndices: number[];
  handleToggle: (index: number) => void;
  dayPartIndex: number;
  dayPartMog: any;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  kitchenSectionCode: string;
  isEditable: boolean;
  handleDeleteMog: (kitchensectioncode: string, daypartcode: string, mogcode: string) => void;
}

const Accordion: React.FC<AccordionProps> = ({ openIndices, handleToggle, dayPartIndex, dayPartMog, searchTerm, setSearchTerm, kitchenSectionCode, isEditable, handleDeleteMog }) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const [showAddMog, setShowAddMog] = useState<boolean>(false);
  const [editMogCode, setEditMogCode] = useState<string>("");
  const { params } = useSelector((state: any) => state.productionPlan);
  const showcostValue = localStorage.getItem('showcost');

  const handleAddMog = (mogcode: string) => {
    dispatch(addMog({
      menuDate: params?.menudate,
      kitchensectioncode: kitchenSectionCode,
      daypartcode: dayPartMog?.daypartcode,
      mogcode,
    })).unwrap().then((res: any) => {
      toast(res?.message, { type: "success" });
      setShowAddMog(prev => !prev);
      dispatch(fetchKitchenIndent({
        menudate: params?.menudate,
        daypartidlist: params?.indentdayparts
      }));
    }).catch((error) => {
      console.error(" add mog API error::", error)
    })
  }

  const handleSaveKitchenIndent = (mogdetails: object) => {
    dispatch(saveKitchenIndent({
      menudate: params?.menudate,
      kitchensectioncode: kitchenSectionCode,
      daypartcode: dayPartMog?.daypartcode,
      ...mogdetails
    })).unwrap().then(() => {
      setEditMogCode("");
      dispatch(fetchKitchenIndent({
        menudate: params?.menudate,
        daypartidlist: params?.indentdayparts
      }));
    }).catch((error) => {
      console.error(" add mog API error::", error)
    })
  }

  useEffect(() => {
    if (showAddMog) {
      setShowAddMog(false);
    }
    setEditMogCode("");
  }, [searchTerm]);

  return (
    <>
      <div className={`innrBox ${openIndices.includes(dayPartIndex) ? 'active' : ''}`}>
        <div className='flex align-items-center justify-content-between'>
          <button
            onClick={() => handleToggle(dayPartIndex)}
            className={`flex align-items-center dropDownButton wd-140 ${openIndices.includes(dayPartIndex) ? 'active' : ''
              }`}
          >
            <span>
              <ExpandMore />
            </span>{' '}
            {dayPartMog?.name}
          </button>
          {showcostValue === 'true' &&
            <div className='flex align-items-center total-cost semi-bold'>
              <span>Total Cost</span>: ₹ {formatCost(dayPartMog?.totalcost, 2)}
            </div>
          }
          <div className='flex align-items-center add-mog'>
            {openIndices.includes(dayPartIndex) && isEditable && <button onClick={() => { if (!showAddMog) { setShowAddMog(true); setSearchTerm(""); } }}><span><IconPlus /></span> Add MOG</button>}
          </div>
        </div>
        {openIndices.includes(dayPartIndex) && (
          <div className='content'>
            {!!dayPartMog?.recipemissingdishes?.length && <div className='recipe-message'>
              <strong>Recipe Missing Dishes:</strong> {dayPartMog?.recipemissingdishes}
            </div>}
            <KitchenIndentTable
              dayPartMogList={dayPartMog?.recipesmoglist?.filter((mog: any) => mog?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) || mog?.aplname?.toLowerCase()?.includes(searchTerm?.toLowerCase()))}
              dayPartCode={dayPartMog?.daypartcode}
              kitchenSectionCode={kitchenSectionCode}
              isEditable={isEditable}
              showAddMog={showAddMog}
              setShowAddMog={setShowAddMog}
              editMogCode={editMogCode}
              setEditMogCode={setEditMogCode}
              handleDeleteMog={handleDeleteMog}
              handleSaveKitchenIndent={handleSaveKitchenIndent}
              handleAddMog={handleAddMog}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Accordion;
